/*
    * Список ожидаемых полей на стороне ReportBuilder

    * Время
    YearBegin
    MonthBegin
    YearEnd
    MonthEnd

    * Остальные сущности
    ObjectID
    ObjectTypeID
    VersionID
    Adler
    DevelopmentObjectID
    ElementID
    FieldID
    VentureID

    Selected_Stratum_IDs -> Stratums
*/

const matches = {
    objectId: 'ObjectID',
    ventureId: 'VentureID',
    objectTypeId: 'ObjectTypeID',
    versionId: 'VersionID',
    fieldId: 'FieldID',
    adler: 'Adler',
    developmentObjectId: 'DevelopmentObjectID',
    elementId: 'ElementID',
    stratumIds: 'Stratums',
};

/*
    Поля фильтра перетрут поля по умолчанию.
*/
const defaultParams = {
    objectId: 0,
    ventureId: 0,
    objectTypeId: 1,
    versionId: 0,
    fieldId: 0,
    adler: 0,
    developmentObjectId: 0,
    elementId: 0,
    stratumIds: 0,
};

export const settingsGosplanParams = (params = {}) => {
    return Object.entries(defaultParams).reduce((acc, param) => {
        const [name, value] = param;

        if (name in params) {
            const value = params[name];
            return { ...acc, [matches[name]]: arrayToString(value) };
        }

        return { ...acc, [matches[name]]: value };
    }, {});
};

function arrayToString(value) {
    return Array.isArray(value) ? value.join(',') : value;
}
